import { textEditingUpdateTextMaker } from 'utils/actions';

export const CHAT_ENQUEUE = 'CHAT_ENQUEUE';
export const CHAT_ENQUEUE_SUCCESS = 'CHAT_ENQUEUE_SUCCESS';
export const CHAT_ENQUEUE_ERROR = 'CHAT_ENQUEUE_ERROR';
export const chatEnqueue = () => ({type: CHAT_ENQUEUE});

export const CHAT_QUEUE_REJECTION_EXPIRE = 'CHAT_QUEUE_REJECTION_EXPIRE';
export const chatQueueRejectionExpire = () => ({type: CHAT_QUEUE_REJECTION_EXPIRE});

export const CHAT_ENQUEUE_CANCEL = 'CHAT_ENQUEUE_CANCEL';
export const CHAT_ENQUEUE_CANCEL_SUCCESS = 'CHAT_ENQUEUE_CANCEL_SUCCESS';
export const CHAT_ENQUEUE_CANCEL_ERROR = 'CHAT_ENQUEUE_CANCEL_ERROR';
export const chatEnqueueCancel = () => ({type: CHAT_ENQUEUE_CANCEL});

export const CHAT_STATE_UPDATE = 'CHAT_STATE_UPDATE';
export const chatStateUpdate = chatStateOnServer => ({type: CHAT_STATE_UPDATE, chatStateOnServer});

export const CHAT_OPEN = 'CHAT_OPEN';
export const chatOpen = () => ({type: CHAT_OPEN});

export const CHAT_CLOSE = 'CHAT_CLOSE';
export const chatClose = () => ({type: CHAT_CLOSE});

export const CHAT_MESSAGES_UPDATE = 'CHAT_MESSAGES_UPDATE';
export const chatMessagesUpdate = (result, initiatedByServer = true) => ({type: CHAT_MESSAGES_UPDATE, result, initiatedByServer});

export const CHAT_ACTIVE_STATE_UPDATE = 'CHAT_ACTIVE_STATE_UPDATE';
export const chatActiveStateUpdate = chatActiveState => ({type: CHAT_ACTIVE_STATE_UPDATE, chatActiveState});

export const CHAT_MESSAGE_ADD = 'CHAT_MESSAGE_ADD';
export const CHAT_MESSAGE_ADD_SUCCESS = 'CHAT_MESSAGE_ADD_SUCCESS';
export const chatMessageAdd = text => ({
  type: CHAT_MESSAGE_ADD,
  chatMessage: {
    text,
    id: Math.random().toString(),
    fromCounsellor: false,
    createdAt: new Date()
  }
});

export const CHAT_MESSAGE_REMOVE = 'CHAT_MESSAGE_REMOVE';
export const chatMessageRemove = id => ({type: CHAT_MESSAGE_REMOVE, id});

export const CHAT_MESSAGE_EDITING_UPDATE_TEXT = 'CHAT_MESSAGE_EDITING_UPDATE_TEXT';
export const chatMessageEditingUpdateText = textEditingUpdateTextMaker(CHAT_MESSAGE_EDITING_UPDATE_TEXT);

export const CHAT_MESSAGE_EDITING_RESET = 'CHAT_MESSAGE_EDITING_RESET';
export const chatMessageEditingReset = () => ({type: CHAT_MESSAGE_EDITING_RESET});

export const CHAT_MESSAGE_UPDATE_WRITING_INDICATOR = 'CHAT_MESSAGE_UPDATE_WRITING_INDICATOR';
export const chatMessageUpdateWritingIndicator = isWriting => ({type: CHAT_MESSAGE_UPDATE_WRITING_INDICATOR, isWriting});

export const CHAT_QUESTIONNAIRES_RECEIVED = 'CHAT_QUESTIONNAIRES_RECEIVED';
export const chatQuestionnairesReceived = (result) => ({type: CHAT_QUESTIONNAIRES_RECEIVED, result});

export const CHAT_QUESTION_UPDATE = 'CHAT_QUESTION_UPDATE';
export const chatQuestionUpdate = (chatQuestionnaireId, chatQuestionId, updates) => ({type: CHAT_QUESTION_UPDATE, chatQuestionnaireId, chatQuestionId, updates});

export const CHAT_QUESTIONNAIRE_UPDATE = 'CHAT_QUESTIONNAIRE_UPDATE';
export const chatQuestionnaireUpdate = (chatQuestionnaireId, updates) => ({type: CHAT_QUESTIONNAIRE_UPDATE, chatQuestionnaireId, updates});

export const CHAT_QUESTIONNAIRE_SUBMIT = 'CHAT_QUESTIONNAIRE_SUBMIT';
export const CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS = 'CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS';
export const CHAT_QUESTIONNAIRE_SUBMIT_ERROR = 'CHAT_QUESTIONNAIRE_SUBMIT_ERROR';
export const chatQuestionnaireSubmit = chatQuestionnaire => ({type: CHAT_QUESTIONNAIRE_SUBMIT, chatQuestionnaire});

export const CHAT_WEBSITES_RECEIVED = 'CHAT_WEBSITES_RECEIVED';
export const chatWebsitesReceived = result => ({type: CHAT_WEBSITES_RECEIVED, result});

export const CHAT_DOCUMENTS_RECEIVED = 'CHAT_DOCUMENTS_RECEIVED';
export const chatDocumentsReceived = result => ({type: CHAT_DOCUMENTS_RECEIVED, result});

export const CHAT_RESOURCES_FETCH = 'CHAT_RESOURCES_FETCH';
export const CHAT_RESOURCES_FETCH_SUCCESS = 'CHAT_RESOURCES_FETCH_SUCCESS';
export const CHAT_RESOURCES_FETCH_ERROR = 'CHAT_RESOURCES_FETCH_ERROR';
export const chatResourcesFetch = (page = 1) => ({type: CHAT_RESOURCES_FETCH, page});

export const CHAT_RESOURCES_UPDATE_POSSIBLE_PAGE = 'MAIL_THREADS_UPDATE_POSSIBLE_PAGE';
export const chatResourcesUpdatePossiblePage = possiblePage => ({type: CHAT_RESOURCES_UPDATE_POSSIBLE_PAGE, possiblePage});

export const CHAT_EMOJIS_SHOW = 'CHAT_EMOJIS_SHOW';
export const chatEmojisShow = key => ({type: CHAT_EMOJIS_SHOW, key});

export const CHAT_EMOJIS_HIDE = 'CHAT_EMOJIS_HIDE';
export const chatEmojisHide = key => ({type: CHAT_EMOJIS_HIDE, key});

export const CHAT_SCHEDULE_FETCH = 'CHAT_SCHEDULE_FETCH';
export const CHAT_SCHEDULE_FETCH_SUCCESS = 'CHAT_SCHEDULE_FETCH_SUCCESS';
export const CHAT_SCHEDULE_FETCH_ERROR = 'CHAT_SCHEDULE_FETCH_ERROR';
export const chatScheduleFetch = () => ({type: CHAT_SCHEDULE_FETCH});




/** WEBPACK FOOTER **
 ** ./src/members/state/chat/actions.js
 **/